import { Navigate, Outlet } from "react-router-dom";
import { useProfileData } from "@/hooks/use-profile-data";

export const ProtectedTenantRoute = () => {
  const { data: profileData, isLoading } = useProfileData();

  // While loading, render Outlet - child components handle their own loading states
  // This avoids double loading spinners (route + child component)
  if (isLoading) {
    return <Outlet />;
  }

  if (profileData?.tenants.length === 0) {
    return <Navigate to="/profile" />;
  }

  return <Outlet />;
};
